<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
      <span @click="logOut" class="nav-link">
        <span class="no-icon">Log out</span>
      </span>
    </li>
  </ul>
</template>

<script>
  import store from '@/vuex/store.js';
  export default {
    name: 'mobile-menu',
    methods: {
      logOut() {
         store.dispatch('logout');
      },  
    }
  }
</script>
<style>
</style>
